import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIGameMapTileView } from './UIGameMapTileView.ts';
export class UIGameBaseTileController {
    drawTile(tile) {
        const tileCenter = tile.hexFace.toPixel(this.uiGameManager.mapController.mapView.mapCenter, this.uiGameManager.mapController.mapView.hexagonHeight / 2);
        const texture = UIGameSpriteHandler.getHexImage(tile.tileType);
        const foregroundTexture = UIGameSpriteHandler.getHexForegroundImage(tile.tileType);
        const hexW = this.uiGameManager.mapController.mapView.hexagonWidth;
        const hexH = this.uiGameManager.mapController.mapView.hexagonHeight;
        const tileView = this.drawTileView(tile, tileCenter, hexW, hexH, texture, foregroundTexture);
        tileView.drawProbability(tile.diceNumber);
        return tileView;
    }
    drawTileView(tile, tileCenter, hexW, hexH, texture, foregroundTexture) {
        const x = tileCenter.x - hexW / 2;
        const y = tileCenter.y - hexH / 2;
        const w = hexW;
        const h = hexH;
        const mapView = this.uiGameManager.mapController.mapView;
        return new UIGameMapTileView(this.uiGameManager, tile.hexFace, x, y, w, h, texture, mapView, foregroundTexture);
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
    }
}
